import React from 'react';
import { BarChart3, Activity } from 'lucide-react';

const Stats: React.FC = () => {
  const stats = [
    {
      icon: <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center text-green-600 font-bold">↗</div>,
      number: "99.9%",
      label: "Uptime Guarantee",
      description: "Enterprise-grade reliability"
    },
    {
      icon: <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">📊</div>,
      number: "500+",
      label: "Protected Organizations",
      description: "Across India & Australia"
    },
    {
      icon: <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center">🔒</div>,
      number: "24/7",
      label: "Security Monitoring",
      description: "Round-the-clock protection"
    },
    {
      icon: <BarChart3 className="h-8 w-8 text-orange-600" />,
      number: "15min",
      label: "Average Response Time",
      description: "Rapid incident response"
    },
    {
      icon: <Activity className="h-8 w-8 text-red-600" />,
      number: "10M+",
      label: "Threats Blocked Daily",
      description: "Advanced threat prevention"
    }
  ];

  return (
    <section className="py-20 bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Trusted by Industry Leaders
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Our proven track record speaks for itself. Join hundreds of organizations 
            that trust CyberSoft to protect their digital assets.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="flex justify-center mb-4">
                {stat.icon}
              </div>
              <div className="text-3xl font-bold text-blue-400 mb-2">{stat.number}</div>
              <div className="text-lg font-semibold mb-1">{stat.label}</div>
              <div className="text-sm text-slate-400">{stat.description}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;